import React from 'react'
import {createRoot} from 'react-dom/client'
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import App from './App'
// MUI Thing
// import CssBaseline from '@mui/styles/'
// Error catcher
import { ErrorBoundary } from './Components/Common'
// MUI Style and Icons
import 'typeface-roboto'
import { ConfigContextProvider } from './Store/ConfigContext';

Sentry.init({
  dsn: "https://b07dfdbb28f346648e74fed1e7152f6d@o805729.ingest.sentry.io/5803277",
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

function AppRender() {
  return (
    <ErrorBoundary>
      <ConfigContextProvider>
        <App />
      </ConfigContextProvider>
    </ErrorBoundary>
  )
}

const domNode = document.getElementById('root');
const root = createRoot(domNode);
root.render(
  <React.StrictMode>
    <AppRender />
  </React.StrictMode>
)
